import { NavbarV2 } from "@/components/landing-v2/NavbarV2";
import { HeroV2 } from "@/components/landing-v2/HeroV2";

import { FeaturesGrid } from "@/components/landing-v2/FeaturesGrid";
import { TemplatesV2 } from "@/components/landing-v2/TemplatesV2";
import { CtaSectionV2 } from "@/components/landing-v2/CtaSectionV2";
import { SupportedModels } from "@/components/landing/SupportedModels";
import { Footer } from "@/components/landing/Footer";

export function LandingPageV2() {
  return (
    <div className="bg-background min-h-screen">
      <NavbarV2 />
      <main>
        <HeroV2 />
        <SupportedModels />
        <FeaturesGrid />
        <TemplatesV2 />
        <CtaSectionV2 />
      </main>
      <Footer />
    </div>
  );
}
